import React, { useMemo } from 'react';
import block from 'bem-cn';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'shared/hooks';
import SVG from 'components/SVG';

import sortSVG from './img/sort.svg';

import './Item.scss';
import number1IMG from './img/number1.webp';
import number2IMG from './img/number2.webp';
import number3IMG from './img/number3.webp';
import { formatNumber } from 'shared/utils/formatNumber';

const b = block('balance-table-row-mobile');

const Item = ({ item, type, setIsAsc, isAsc }) => {
  const icon = useMemo(() => {
    if (item.rank === 1) return number1IMG;
    if (item.rank === 2) return number2IMG;
    if (item.rank === 3) return number3IMG;
    return null;
  }, [item.rank]);

  const locale = useAppSelector(state => state.locale.locale);

  return (
    <div
      className={b({
        top: Boolean(icon),
      })}>
      <div className={b('top')}>
        {icon && (
          <div className={b('top-icon-wrapper')}>
            <img
              className={b('top-icon', {
                variant: item.rank,
              })}
              src={icon}
              alt=""
            />
          </div>
        )}
        <div className={b('top-content')}>
          <div className={b('header')}>
            <div className={b('header-col')}>
              <div className={b('header-id')}>
                <span className={b('header-id-label')}>{locale.id}:</span>
                <span className={b('header-id-value')}>{item.id}</span>
              </div>
              <div className={b('header-username')}>{item.username}</div>
            </div>
          </div>
          <div className={b('row')}>
            <span className={b('row-label')}>{locale.actualBalance}</span>
            <span className={b('row-value')}>{item.actualBalance}</span>
          </div>
        </div>
      </div>

      <div className={b('body')}>
        <div className={b('body-col')}>
          <div className={b('row')}>
            <span className={b('row-label')}>{locale.startBalance}</span>
            <span className={b('row-value')}>{item.startBalance}</span>
          </div>
          <div className={b('row')}>
            <span className={b('row-label')}>{locale.endBalance}</span>
            <span className={b('row-value')}>{item.endBalance}</span>
          </div>
        </div>
        <div className={b('change-balance')}>
          <div className={b('change-balance-header')}>
            <span className={b('change-balance-title')}>{locale.changeBalance}</span>
            {/* <div
              className={b('change-balance-button')}
              onClick={() => {
                setIsAsc(ps => !ps);
              }}>
              <SVG
                containerClassName={b('change-balance-button-icon', {
                  asc: isAsc,
                })}
                svgProps={{
                  svg: sortSVG,
                }}
              />
            </div> */}
          </div>
          <div
            className={b('change-balance-value', {
              negative: item.changeBalance < 0,
              positive: item.changeBalance >= 0,
            })}>
            {formatNumber(item.changeBalance)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Item;
